const state = {
  clientModel: null
}

const mutations = {
  set_client_model(state, payload) {
    state.clientModel = payload
  }
}

const actions = {
  setCurrentPageData: ({ commit }, payload) => commit('set_client_model', payload)
}

const getters = {
  clientModel: state => state.clientModel,
  enableGtm: state => state.clientModel.enableGtm,
  enableArticleWatch: state => state.clientModel.enableArticleWatch,
  currentVehicle: state => state.clientModel.currentVehicle,
  longDeliveryTimeLeadTime: state => state.clientModel.longDeliveryTimeLeadTime
}

export default {
  state,
  getters,
  actions,
  mutations
}
